import {
  DELETE_AUTHORIZATIONS_FAILURE,
  DELETE_AUTHORIZATIONS_REQUEST,
  DELETE_AUTHORIZATIONS_SUCCESS,
  DELETE_AUTH_LIST_CLIENT_POLICIES_FAILURE,
  DELETE_AUTH_LIST_CLIENT_POLICIES_REQUEST,
  DELETE_AUTH_LIST_CLIENT_POLICIES_SUCCESS,
  DELETE_AUTH_SERVICES_FAILURE,
  DELETE_AUTH_SERVICES_REQUEST,
  DELETE_AUTH_SERVICES_SUCCESS,
  DELETE_FAMILY_FAILURE,
  DELETE_FAMILY_PET_FAILURE,
  DELETE_FAMILY_PET_REQUEST,
  DELETE_FAMILY_PET_SUCCESS,
  DELETE_FAMILY_REQUEST,
  DELETE_FAMILY_SUCCESS,
  GET_ACTIVITY_LOG_FAILURE,
  GET_ACTIVITY_LOG_REQUEST,
  GET_ACTIVITY_LOG_SUCCESS,
  GET_ALL_AUTH_SERVICES_FAILURE,
  GET_ALL_AUTH_SERVICES_REQUEST,
  GET_ALL_AUTH_SERVICES_SUCCESS,
  GET_AUTHORIZATIONS_FAILURE,
  GET_AUTHORIZATIONS_REQUEST,
  GET_AUTHORIZATIONS_SUCCESS,
  GET_PENDING_AUTHS_FAILURE,
  GET_PENDING_AUTHS_REQUEST,
  GET_PENDING_AUTHS_SUCCESS,
  GET_AUTH_CLIENT_POLICIES_FAILURE,
  GET_AUTH_CLIENT_POLICIES_REQUEST,
  GET_AUTH_CLIENT_POLICIES_SUCCESS,
  GET_AUTH_DATE_SUMMARY_FAILURE,
  GET_AUTH_DATE_SUMMARY_REQUEST,
  GET_AUTH_DATE_SUMMARY_SUCCESS,
  GET_AUTH_LIST_CLIENT_POLICIES_BY_CLIENT_FAILURE,
  GET_AUTH_LIST_CLIENT_POLICIES_BY_CLIENT_REQUEST,
  GET_AUTH_LIST_CLIENT_POLICIES_BY_CLIENT_SUCCESS,
  GET_AUTH_LIST_CLIENT_POLICIES_FAILURE,
  GET_AUTH_LIST_CLIENT_POLICIES_REQUEST,
  GET_AUTH_LIST_CLIENT_POLICIES_SUCCESS,
  GET_AUTH_SERVICES_FAILURE,
  GET_AUTH_SERVICES_REQUEST,
  GET_AUTH_SERVICES_SUCCESS,
  GET_AUTH_SUMMARY_FAILURE,
  GET_AUTH_SUMMARY_REQUEST,
  GET_AUTH_SUMMARY_SUCCESS,
  GET_AUTH_TEAM_FAILURE,
  GET_AUTH_TEAM_REQUEST,
  GET_AUTH_TEAM_SUCCESS,
  GET_COMMUNICATION_INFO_FAILURE,
  GET_COMMUNICATION_INFO_REQUEST,
  GET_COMMUNICATION_INFO_SUCCESS,
  GET_DEPARTURE_ADDRESS_FAILURE,
  GET_DEPARTURE_ADDRESS_REQUEST,
  GET_DEPARTURE_ADDRESS_SUCCESS,
  GET_DESTINATION_ADDRESS_FAILURE,
  GET_DESTINATION_ADDRESS_REQUEST,
  GET_DESTINATION_ADDRESS_SUCCESS,
  GET_EMPLOYEE_INFO_FAILURE,
  GET_EMPLOYEE_INFO_REQUEST,
  GET_EMPLOYEE_INFO_SUCCESS,
  GET_FAMILY_FAILURE,
  GET_FAMILY_PET_FAILURE,
  GET_FAMILY_PET_REQUEST,
  GET_FAMILY_PET_SUCCESS,
  GET_FAMILY_REQUEST,
  GET_FAMILY_SUCCESS,
  GET_SO_INFO_FAILURE,
  GET_SO_INFO_REQUEST,
  GET_SO_INFO_SUCCESS,
  GET_USER_SETTINGS_FAILURE,
  GET_USER_SETTINGS_REQUEST,
  GET_USER_SETTINGS_SUCCESS,
  POST_AUTHORIZATIONS_FAILURE,
  POST_AUTHORIZATIONS_REQUEST,
  POST_AUTHORIZATIONS_SUCCESS,
  POST_AUTH_CLIENT_POLICIES_FAILURE,
  POST_AUTH_CLIENT_POLICIES_REQUEST,
  POST_AUTH_CLIENT_POLICIES_SUCCESS,
  POST_AUTH_DATE_SUMMARY_FAILURE,
  POST_AUTH_DATE_SUMMARY_REQUEST,
  POST_AUTH_DATE_SUMMARY_SUCCESS,
  POST_AUTH_LIST_CLIENT_POLICIES_FAILURE,
  POST_AUTH_LIST_CLIENT_POLICIES_REQUEST,
  POST_AUTH_LIST_CLIENT_POLICIES_SUCCESS,
  POST_AUTH_SERVICES_FAILURE,
  POST_AUTH_SERVICES_REQUEST,
  POST_AUTH_SERVICES_SUCCESS,
  POST_AUTH_TEAM_FAILURE,
  POST_AUTH_TEAM_REQUEST,
  POST_AUTH_TEAM_SUCCESS,
  POST_COMMUNICATION_INFO_FAILURE,
  POST_COMMUNICATION_INFO_REQUEST,
  POST_COMMUNICATION_INFO_SUCCESS,
  POST_DEPARTURE_ADDRESS_FAILURE,
  POST_DEPARTURE_ADDRESS_REQUEST,
  POST_DEPARTURE_ADDRESS_SUCCESS,
  POST_DESTINATION_ADDRESS_FAILURE,
  POST_DESTINATION_ADDRESS_REQUEST,
  POST_DESTINATION_ADDRESS_SUCCESS,
  POST_EMPLOYEE_INFO_FAILURE,
  POST_EMPLOYEE_INFO_REQUEST,
  POST_EMPLOYEE_INFO_SUCCESS,
  POST_FAMILY_FAILURE,
  POST_FAMILY_PET_FAILURE,
  POST_FAMILY_PET_REQUEST,
  POST_FAMILY_PET_SUCCESS,
  POST_FAMILY_REQUEST,
  POST_FAMILY_SUCCESS,
  POST_SO_INFO_FAILURE,
  POST_SO_INFO_REQUEST,
  POST_SO_INFO_SUCCESS,
  POST_USER_SETTINGS_FAILURE,
  POST_USER_SETTINGS_REQUEST,
  POST_USER_SETTINGS_SUCCESS,
  SET_AUTH_ID,
  SET_LOADING_COMPLETE,
  UPDATE_AUTHORIZATIONS_FAILURE,
  UPDATE_AUTHORIZATIONS_REQUEST,
  UPDATE_AUTHORIZATIONS_SUCCESS,
  UPDATE_AUTH_CLIENT_POLICIES_FAILURE,
  UPDATE_AUTH_CLIENT_POLICIES_REQUEST,
  UPDATE_AUTH_CLIENT_POLICIES_SUCCESS,
  UPDATE_AUTH_DATE_SUMMARY_FAILURE,
  UPDATE_AUTH_DATE_SUMMARY_REQUEST,
  UPDATE_AUTH_DATE_SUMMARY_SUCCESS,
  UPDATE_AUTH_LIST_CLIENT_POLICIES_FAILURE,
  UPDATE_AUTH_LIST_CLIENT_POLICIES_REQUEST,
  UPDATE_AUTH_LIST_CLIENT_POLICIES_SUCCESS,
  UPDATE_AUTH_SERVICES_FAILURE,
  UPDATE_AUTH_SERVICES_REQUEST,
  UPDATE_AUTH_SERVICES_SUCCESS,
  UPDATE_AUTH_TEAM_FAILURE,
  UPDATE_AUTH_TEAM_REQUEST,
  UPDATE_AUTH_TEAM_SUCCESS,
  UPDATE_COMMUNICATION_INFO_FAILURE,
  UPDATE_COMMUNICATION_INFO_REQUEST,
  UPDATE_COMMUNICATION_INFO_SUCCESS,
  UPDATE_DEPARTURE_ADDRESS_FAILURE,
  UPDATE_DEPARTURE_ADDRESS_REQUEST,
  UPDATE_DEPARTURE_ADDRESS_SUCCESS,
  UPDATE_DESTINATION_ADDRESS_FAILURE,
  UPDATE_DESTINATION_ADDRESS_REQUEST,
  UPDATE_DESTINATION_ADDRESS_SUCCESS,
  UPDATE_EMPLOYEE_INFO_FAILURE,
  UPDATE_EMPLOYEE_INFO_REQUEST,
  UPDATE_EMPLOYEE_INFO_SUCCESS,
  UPDATE_FAMILY_DATA,
  UPDATE_FAMILY_FAILURE,
  UPDATE_FAMILY_PET_DATA,
  UPDATE_FAMILY_PET_FAILURE,
  UPDATE_FAMILY_PET_REQUEST,
  UPDATE_FAMILY_PET_SUCCESS,
  UPDATE_FAMILY_REQUEST,
  UPDATE_FAMILY_SUCCESS,
  UPDATE_SO_INFO_FAILURE,
  UPDATE_SO_INFO_REQUEST,
  UPDATE_SO_INFO_SUCCESS,
  UPDATE_USER_SETTINGS_FAILURE,
  UPDATE_USER_SETTINGS_REQUEST,
  UPDATE_USER_SETTINGS_SUCCESS,
  GET_FINANCE_AND_TAX_FAILURE,
  GET_FINANCE_AND_TAX_REQUEST,
  GET_FINANCE_AND_TAX_SUCCESS,
  POST_FINANCE_AND_TAX_FAILURE,
  POST_FINANCE_AND_TAX_REQUEST,
  POST_FINANCE_AND_TAX_SUCCESS,
  UPDATE_FINANCE_AND_TAX_FAILURE,
  UPDATE_FINANCE_AND_TAX_REQUEST,
  UPDATE_FINANCE_AND_TAX_SUCCESS,
  GET_ADDRESS_REQUEST,
  GET_ADDRESS_SUCCESS,
  GET_ADDRESS_FAILURE,
  POST_ADDRESS_REQUEST,
  POST_ADDRESS_SUCCESS,
  POST_ADDRESS_FAILURE,
  UPDATE_ADDRESS_REQUEST,
  UPDATE_ADDRESS_SUCCESS,
  UPDATE_ADDRESS_FAILURE,
  DELETE_ADDRESS_REQUEST,
  DELETE_ADDRESS_SUCCESS,
  DELETE_ADDRESS_FAILURE,
  GET_AUTH_TRIPS_FAILURE,
  GET_AUTH_TRIPS_REQUEST,
  GET_AUTH_TRIPS_SUCCESS,
  POST_AUTH_TRIP_FAILURE,
  POST_AUTH_TRIP_REQUEST,
  POST_AUTH_TRIP_SUCCESS,
  UPDATE_AUTH_TRIP_FAILURE,
  UPDATE_AUTH_TRIP_REQUEST,
  UPDATE_AUTH_TRIP_SUCCESS,
  DELETE_AUTH_TRIP_FAILURE,
  DELETE_AUTH_TRIP_REQUEST,
  DELETE_AUTH_TRIP_SUCCESS,
  GET_AUTH_TRIP_BY_ID_REQUEST,
  GET_AUTH_TRIP_BY_ID_FAILURE,
  GET_AUTH_TRIP_BY_ID_SUCCESS,
  GET_AUTHORIZATION_BANKING_REQUEST,
  GET_AUTHORIZATION_BANKING_SUCCESS,
  GET_AUTHORIZATION_BANKING_FAILURE,
  POST_AUTHORIZATION_BANKING_REQUEST,
  POST_AUTHORIZATION_BANKING_SUCCESS,
  POST_AUTHORIZATION_BANKING_FAILURE,
  UPDATE_AUTHORIZATION_BANKING_REQUEST,
  UPDATE_AUTHORIZATION_BANKING_SUCCESS,
  UPDATE_AUTHORIZATION_BANKING_FAILURE,
  DELETE_AUTHORIZATION_BANKING_REQUEST,
  DELETE_AUTHORIZATION_BANKING_SUCCESS,
  DELETE_AUTHORIZATION_BANKING_FAILURE,
  GET_AUTHORIZATION_AREA_TOUR_FAILURE,
  GET_AUTHORIZATION_AREA_TOUR_REQUEST,
  GET_AUTHORIZATION_AREA_TOUR_SUCCESS,
  POST_AUTHORIZATION_AREA_TOUR_FAILURE,
  POST_AUTHORIZATION_AREA_TOUR_REQUEST,
  POST_AUTHORIZATION_AREA_TOUR_SUCCESS,
  UPDATE_AUTHORIZATION_AREA_TOUR_FAILURE,
  UPDATE_AUTHORIZATION_AREA_TOUR_REQUEST,
  UPDATE_AUTHORIZATION_AREA_TOUR_SUCCESS,
  DELETE_AUTHORIZATION_AREA_TOUR_FAILURE,
  DELETE_AUTHORIZATION_AREA_TOUR_REQUEST,
  DELETE_AUTHORIZATION_AREA_TOUR_SUCCESS,
  GET_AUTHORIZATION_COMMENTS_REQUEST,
  GET_AUTHORIZATION_COMMENTS_SUCCESS,
  GET_AUTHORIZATION_COMMENTS_FAILURE,
  DELETE_AUTHORIZATION_COMMENTS_REQUEST,
  DELETE_AUTHORIZATION_COMMENTS_SUCCESS,
  DELETE_AUTHORIZATION_COMMENTS_FAILURE,
  POST_AUTHORIZATION_COMMENTS_REQUEST,
  POST_AUTHORIZATION_COMMENTS_SUCCESS,
  POST_AUTHORIZATION_COMMENTS_FAILURE,
  UPDATE_AUTHORIZATION_COMMENTS_FAILURE,
  UPDATE_AUTHORIZATION_COMMENTS_SUCCESS,
  UPDATE_AUTHORIZATION_COMMENTS_REQUEST,
  GET_AUTHORIZATION_SENT_TEMPLATES_REQUEST,
  GET_AUTHORIZATION_SENT_TEMPLATES_FAILURE,
  GET_AUTHORIZATION_SENT_TEMPLATES_SUCCESS,
  GET_AUTH_CUSTOM_FIELDS_AND_VALUES_FAILURE,
  GET_AUTH_CUSTOM_FIELDS_AND_VALUES_REQUEST,
  GET_AUTH_CUSTOM_FIELDS_AND_VALUES_SUCCESS,
  GET_AUTH_CUSTOM_FIELD_VALUES_FAILURE,
  GET_AUTH_CUSTOM_FIELD_VALUES_REQUEST,
  GET_AUTH_CUSTOM_FIELD_VALUES_SUCCESS,
  POST_ALL_AUTH_CUSTOM_FIELD_VALUE_FAILURE,
  POST_ALL_AUTH_CUSTOM_FIELD_VALUE_REQUEST,
  POST_ALL_AUTH_CUSTOM_FIELD_VALUE_SUCCESS,
  POST_AUTH_CUSTOM_FIELD_VALUE_FAILURE,
  POST_AUTH_CUSTOM_FIELD_VALUE_REQUEST,
  POST_AUTH_CUSTOM_FIELD_VALUE_SUCCESS,
  POST_AUTH_PT_CODE_FAILURE,
  POST_AUTH_PT_CODE_REQUEST,
  POST_AUTH_PT_CODE_SUCCESS,
  UPDATE_AUTH_CUSTOM_FIELD_VALUE_FAILURE,
  UPDATE_AUTH_CUSTOM_FIELD_VALUE_REQUEST,
  UPDATE_AUTH_CUSTOM_FIELD_VALUE_SUCCESS,
  UPDATE_AUTH_PT_CODE_FAILURE,
  UPDATE_AUTH_PT_CODE_REQUEST,
  UPDATE_AUTH_PT_CODE_SUCCESS,
  DELETE_AUTH_CUSTOM_FIELD_VALUE_FAILURE,
  DELETE_AUTH_CUSTOM_FIELD_VALUE_REQUEST,
  DELETE_AUTH_CUSTOM_FIELD_VALUE_SUCCESS,
  DELETE_AUTH_PT_CODE_FAILURE,
  DELETE_AUTH_PT_CODE_REQUEST,
  DELETE_AUTH_PT_CODE_SUCCESS,
  POST_AUTH_COMMENTS_ATTACHMENT_REQUEST,
  POST_AUTH_COMMENTS_ATTACHMENT_SUCCESS,
  POST_AUTH_COMMENTS_ATTACHMENT_FAILURE,
  UPDATE_AUTH_COMMENTS_ATTACHMENT_REQUEST,
  UPDATE_AUTH_COMMENTS_ATTACHMENT_SUCCESS,
  UPDATE_AUTH_COMMENTS_ATTACHMENT_FAILURE,
  DELETE_AUTH_COMMENTS_ATTACHMENT_REQUEST,
  DELETE_AUTH_COMMENTS_ATTACHMENT_SUCCESS,
  DELETE_AUTH_COMMENTS_ATTACHMENT_FAILURE,
  GET_FILE_TASKS_REQUEST,
  GET_FILE_TASKS_SUCCESS,
  GET_FILE_TASKS_FAILURE,
  CREATE_FILE_TASK_REQUEST,
  CREATE_FILE_TASK_SUCCESS,
  CREATE_FILE_TASK_FAILURE,
  GET_FEE_RECORDS_REQUEST,
  GET_FEE_RECORDS_SUCCESS,
  GET_FEE_RECORDS_FAILURE,
  GET_SERVICE_STATUS_DATES_FAILURE,
  GET_SERVICE_STATUS_DATES_REQUEST,
  GET_SERVICE_STATUS_DATES_SUCCESS,
  GET_AUTH_SUMMARY_ADDRESS_REQUEST,
  GET_AUTH_SUMMARY_ADDRESS_SUCCESS,
  GET_AUTH_SUMMARY_ADDRESS_FAILURE,
  GET_SIMILAR_AUTHORIZATIONS_REQUEST,
  GET_SIMILAR_AUTHORIZATIONS_SUCCESS,
  GET_SIMILAR_AUTHORIZATIONS_FAILURE,
  RESEND_WELCOME_EMAIL_REQUEST,
  RESEND_WELCOME_EMAIL_SUCCESS,
  RESEND_WELCOME_EMAIL_FAILURE
} from '../types/authorizationTypes';

import { CALL_INTAKE_V2_API } from 'middleware/intakeV2Api';

export const getAuthorizationSummaries = () => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [GET_AUTHORIZATIONS_REQUEST, GET_AUTHORIZATIONS_SUCCESS, GET_AUTHORIZATIONS_FAILURE],
      authenticated: true,
      endpoint: 'api/authorizations/summaries',
      method: 'GET'
    }
  };
};

export const getSubmittedTempFiles = () => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [GET_PENDING_AUTHS_REQUEST, GET_PENDING_AUTHS_SUCCESS, GET_PENDING_AUTHS_FAILURE],
      authenticated: true,
      endpoint: 'api/tempfiles/submitted',
      method: 'GET'
    }
  };
};

export const getAuthorizationSummary = id => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [GET_AUTH_SUMMARY_REQUEST, GET_AUTH_SUMMARY_SUCCESS, GET_AUTH_SUMMARY_FAILURE],
      authenticated: true,
      endpoint: `api/authorizations/${id}`,
      method: 'GET'
    }
  };
};

export const getAuthorizationSummaryAddress = id => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [GET_AUTH_SUMMARY_ADDRESS_REQUEST, GET_AUTH_SUMMARY_ADDRESS_SUCCESS, GET_AUTH_SUMMARY_ADDRESS_FAILURE],
      authenticated: true,
      endpoint: `api/authorizations/${id}`,
      method: 'GET'
    }
  };
};

export const postAuthorizationSummary = values => {
  // const username = localStorage.getItem('username') ? localStorage.getItem('username') : '';
  return {
    [CALL_INTAKE_V2_API]: {
      types: [POST_AUTHORIZATIONS_REQUEST, POST_AUTHORIZATIONS_SUCCESS, POST_AUTHORIZATIONS_FAILURE],
      authenticated: true,
      endpoint: `api/authorizations/`,
      method: 'POST',
      payload: values
    }
  };
};

export const updateAuthorizationSummary = values => {
  // const username = localStorage.getItem('username') ? localStorage.getItem('username') : '';
  return {
    [CALL_INTAKE_V2_API]: {
      types: [UPDATE_AUTHORIZATIONS_REQUEST, UPDATE_AUTHORIZATIONS_SUCCESS, UPDATE_AUTHORIZATIONS_FAILURE],
      authenticated: true,
      endpoint: `api/authorizations/${values.fileId}`,
      method: 'PUT',
      payload: values
    }
  };
};

export const deleteAuthorizationSummary = authId => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [DELETE_AUTHORIZATIONS_REQUEST, DELETE_AUTHORIZATIONS_SUCCESS, DELETE_AUTHORIZATIONS_FAILURE],
      authenticated: true,
      endpoint: `api/authorizations/${authId}`,
      method: 'DELETE'
    }
  };
};

export const getEmployeeInfo = id => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [GET_EMPLOYEE_INFO_REQUEST, GET_EMPLOYEE_INFO_SUCCESS, GET_EMPLOYEE_INFO_FAILURE],
      authenticated: true,
      endpoint: `api/authorizations/${id}/employee`,
      method: 'GET'
    }
  };
};

export const postEmployeeInfo = values => {
  const username = localStorage.getItem('username') ? localStorage.getItem('username') : '';
  return {
    [CALL_INTAKE_V2_API]: {
      types: [POST_EMPLOYEE_INFO_REQUEST, POST_EMPLOYEE_INFO_SUCCESS, POST_EMPLOYEE_INFO_FAILURE],
      authenticated: true,
      endpoint: `api/authorizations/employee/${username}`,
      method: 'POST',
      payload: values
    }
  };
};

export const updateEmployeeInfo = values => {
  const username = localStorage.getItem('username') ? localStorage.getItem('username') : '';
  return {
    [CALL_INTAKE_V2_API]: {
      types: [UPDATE_EMPLOYEE_INFO_REQUEST, UPDATE_EMPLOYEE_INFO_SUCCESS, UPDATE_EMPLOYEE_INFO_FAILURE],
      authenticated: true,
      endpoint: `api/authorizations/employee/${username}`,
      method: 'PUT',
      payload: values
    }
  };
};

export const getSOInfo = id => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [GET_SO_INFO_REQUEST, GET_SO_INFO_SUCCESS, GET_SO_INFO_FAILURE],
      authenticated: true,
      endpoint: `api/authorizations/${id}/significantOther`,
      method: 'GET'
    }
  };
};

export const postSOInfo = values => {
  const username = localStorage.getItem('username') ? localStorage.getItem('username') : '';
  return {
    [CALL_INTAKE_V2_API]: {
      types: [POST_SO_INFO_REQUEST, POST_SO_INFO_SUCCESS, POST_SO_INFO_FAILURE],
      authenticated: true,
      endpoint: `api/authorizations/significantOther/${username}`,
      method: 'POST',
      payload: values
    }
  };
};

export const updateSOInfo = values => {
  const username = localStorage.getItem('username') ? localStorage.getItem('username') : '';
  return {
    [CALL_INTAKE_V2_API]: {
      types: [UPDATE_SO_INFO_REQUEST, UPDATE_SO_INFO_SUCCESS, UPDATE_SO_INFO_FAILURE],
      authenticated: true,
      endpoint: `api/authorizations/significantOther/${username}`,
      method: 'PUT',
      payload: values
    }
  };
};

export const getCommunicationInfo = id => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [GET_COMMUNICATION_INFO_REQUEST, GET_COMMUNICATION_INFO_SUCCESS, GET_COMMUNICATION_INFO_FAILURE],
      authenticated: true,
      endpoint: `api/authorizations/${id}/communication`,
      method: 'GET'
    }
  };
};

export const postCommunicationInfo = values => {
  const username = localStorage.getItem('username') ? localStorage.getItem('username') : '';
  return {
    [CALL_INTAKE_V2_API]: {
      types: [POST_COMMUNICATION_INFO_REQUEST, POST_COMMUNICATION_INFO_SUCCESS, POST_COMMUNICATION_INFO_FAILURE],
      authenticated: true,
      endpoint: `api/authorizations/communication/${username}`,
      method: 'POST',
      payload: values
    }
  };
};

export const updateCommunicationInfo = values => {
  const username = localStorage.getItem('username') ? localStorage.getItem('username') : '';
  return {
    [CALL_INTAKE_V2_API]: {
      types: [UPDATE_COMMUNICATION_INFO_REQUEST, UPDATE_COMMUNICATION_INFO_SUCCESS, UPDATE_COMMUNICATION_INFO_FAILURE],
      authenticated: true,
      endpoint: `api/authorizations/communication/${username}`,
      method: 'PUT',
      payload: values
    }
  };
};

export const setLoadingComplete = () => ({
  type: SET_LOADING_COMPLETE
});

export const setAuthId = id => ({
  type: SET_AUTH_ID,
  response: id
});

export const getAuthDateSummary = id => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [GET_AUTH_DATE_SUMMARY_REQUEST, GET_AUTH_DATE_SUMMARY_SUCCESS, GET_AUTH_DATE_SUMMARY_FAILURE],
      authenticated: true,
      endpoint: `api/authorizations/${id}/summary`,
      method: 'GET'
    }
  };
};

export const postAuthDateSummary = values => {
  const username = localStorage.getItem('username') ? localStorage.getItem('username') : '';
  return {
    [CALL_INTAKE_V2_API]: {
      types: [POST_AUTH_DATE_SUMMARY_REQUEST, POST_AUTH_DATE_SUMMARY_SUCCESS, POST_AUTH_DATE_SUMMARY_FAILURE],
      authenticated: true,
      endpoint: `api/authorizations/summary/${username}`,
      method: 'POST',
      payload: values
    }
  };
};

export const updateAuthDateSummary = values => {
  const username = localStorage.getItem('username') ? localStorage.getItem('username') : '';
  return {
    [CALL_INTAKE_V2_API]: {
      types: [UPDATE_AUTH_DATE_SUMMARY_REQUEST, UPDATE_AUTH_DATE_SUMMARY_SUCCESS, UPDATE_AUTH_DATE_SUMMARY_FAILURE],
      authenticated: true,
      endpoint: `api/authorizations/summary/${username}`,
      method: 'PUT',
      payload: values
    }
  };
};

export const getDepartureAddress = id => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [GET_DEPARTURE_ADDRESS_REQUEST, GET_DEPARTURE_ADDRESS_SUCCESS, GET_DEPARTURE_ADDRESS_FAILURE],
      authenticated: true,
      endpoint: `api/authorizations/${id}/departure`,
      method: 'GET'
    }
  };
};

export const postDepartureAddress = values => {
  const username = localStorage.getItem('username') ? localStorage.getItem('username') : '';
  return {
    [CALL_INTAKE_V2_API]: {
      types: [POST_DEPARTURE_ADDRESS_REQUEST, POST_DEPARTURE_ADDRESS_SUCCESS, POST_DEPARTURE_ADDRESS_FAILURE],
      authenticated: true,
      endpoint: `api/authorizations/departure/${username}`,
      method: 'POST',
      payload: values
    }
  };
};

export const updateDepartureAddress = values => {
  const username = localStorage.getItem('username') ? localStorage.getItem('username') : '';
  return {
    [CALL_INTAKE_V2_API]: {
      types: [UPDATE_DEPARTURE_ADDRESS_REQUEST, UPDATE_DEPARTURE_ADDRESS_SUCCESS, UPDATE_DEPARTURE_ADDRESS_FAILURE],
      authenticated: true,
      endpoint: `api/authorizations/departure/${username}`,
      method: 'PUT',
      payload: values
    }
  };
};

export const getDestinationAddress = id => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [GET_DESTINATION_ADDRESS_REQUEST, GET_DESTINATION_ADDRESS_SUCCESS, GET_DESTINATION_ADDRESS_FAILURE],
      authenticated: true,
      endpoint: `api/authorizations/${id}/destination`,
      method: 'GET'
    }
  };
};

export const postDestinationAddress = values => {
  const username = localStorage.getItem('username') ? localStorage.getItem('username') : '';
  return {
    [CALL_INTAKE_V2_API]: {
      types: [POST_DESTINATION_ADDRESS_REQUEST, POST_DESTINATION_ADDRESS_SUCCESS, POST_DESTINATION_ADDRESS_FAILURE],
      authenticated: true,
      endpoint: `api/authorizations/destination/${username}`,
      method: 'POST',
      payload: values
    }
  };
};

export const updateDestinationAddress = values => {
  const username = localStorage.getItem('username') ? localStorage.getItem('username') : '';
  return {
    [CALL_INTAKE_V2_API]: {
      types: [UPDATE_DESTINATION_ADDRESS_REQUEST, UPDATE_DESTINATION_ADDRESS_SUCCESS, UPDATE_DESTINATION_ADDRESS_FAILURE],
      authenticated: true,
      endpoint: `api/authorizations/destination/${username}`,
      method: 'PUT',
      payload: values
    }
  };
};

export const getAuthClientPolicies = id => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [GET_AUTH_CLIENT_POLICIES_REQUEST, GET_AUTH_CLIENT_POLICIES_SUCCESS, GET_AUTH_CLIENT_POLICIES_FAILURE],
      authenticated: true,
      endpoint: `api/authorizations/${id}/clientPolicy`,
      method: 'GET'
    }
  };
};

export const postAuthClientPolicies = values => {
  const username = localStorage.getItem('username') ? localStorage.getItem('username') : '';
  return {
    [CALL_INTAKE_V2_API]: {
      types: [POST_AUTH_CLIENT_POLICIES_REQUEST, POST_AUTH_CLIENT_POLICIES_SUCCESS, POST_AUTH_CLIENT_POLICIES_FAILURE],
      authenticated: true,
      endpoint: `api/authorizations/clientPolicy/${username}`,
      method: 'POST',
      payload: values
    }
  };
};

export const updateAuthClientPolicies = values => {
  const username = localStorage.getItem('username') ? localStorage.getItem('username') : '';
  return {
    [CALL_INTAKE_V2_API]: {
      types: [UPDATE_AUTH_CLIENT_POLICIES_REQUEST, UPDATE_AUTH_CLIENT_POLICIES_SUCCESS, UPDATE_AUTH_CLIENT_POLICIES_FAILURE],
      authenticated: true,
      endpoint: `api/authorizations/clientPolicy/${username}`,
      method: 'PUT',
      payload: values
    }
  };
};

/* Team calls */
export const getTeam = id => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [GET_AUTH_TEAM_REQUEST, GET_AUTH_TEAM_SUCCESS, GET_AUTH_TEAM_FAILURE],
      authenticated: true,
      endpoint: `api/authorizations/${id}/team`,
      method: 'GET'
    }
  };
};

export const postTeam = (values, fileId) => {
  // const username = localStorage.getItem('username') ? localStorage.getItem('username') : '';
  return {
    [CALL_INTAKE_V2_API]: {
      types: [POST_AUTH_TEAM_REQUEST, POST_AUTH_TEAM_SUCCESS, POST_AUTH_TEAM_FAILURE],
      authenticated: true,
      endpoint: `api/authorizations/${fileId}/representatives`,
      method: 'POST',
      payload: values
    }
  };
};

export const updateTeam = (values, fileId) => {
  // const username = localStorage.getItem('username') ? localStorage.getItem('username') : '';
  return {
    [CALL_INTAKE_V2_API]: {
      types: [UPDATE_AUTH_TEAM_REQUEST, UPDATE_AUTH_TEAM_SUCCESS, UPDATE_AUTH_TEAM_FAILURE],
      authenticated: true,
      endpoint: `api/authorizations/${fileId}/representatives`,
      method: 'PUT',
      payload: values
    }
  };
};

/* Services calls */

export const getAuthServices = () => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [GET_ALL_AUTH_SERVICES_REQUEST, GET_ALL_AUTH_SERVICES_SUCCESS, GET_ALL_AUTH_SERVICES_FAILURE],
      authenticated: true,
      endpoint: 'api/authorizations/authService',
      method: 'GET'
    }
  };
};

export const getServices = id => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [GET_AUTH_SERVICES_REQUEST, GET_AUTH_SERVICES_SUCCESS, GET_AUTH_SERVICES_FAILURE],
      authenticated: true,
      endpoint: `api/authorizations/${id}/authService`,
      method: 'GET'
    }
  };
};

export const postServices = (id, services) => {
  // const username = localStorage.getItem('username') ? localStorage.getItem('username') : '';
  return {
    [CALL_INTAKE_V2_API]: {
      types: [POST_AUTH_SERVICES_REQUEST, POST_AUTH_SERVICES_SUCCESS, POST_AUTH_SERVICES_FAILURE],
      authenticated: true,
      endpoint: `api/authorizations/${id}/services`,
      method: 'POST',
      payload: services
    }
  };
};

export const updateServices = (id, services) => {
  // const username = localStorage.getItem('username') ? localStorage.getItem('username') : '';
  return {
    [CALL_INTAKE_V2_API]: {
      types: [UPDATE_AUTH_SERVICES_REQUEST, UPDATE_AUTH_SERVICES_SUCCESS, UPDATE_AUTH_SERVICES_FAILURE],
      authenticated: true,
      endpoint: `api/authorizations/${id}/services`,
      method: 'PUT',
      payload: services
    }
  };
};

export const deleteServices = id => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [DELETE_AUTH_SERVICES_REQUEST, DELETE_AUTH_SERVICES_SUCCESS, DELETE_AUTH_SERVICES_FAILURE],
      authenticated: true,
      endpoint: `api/authorizations/${id}/authService`,
      method: 'DELETE'
    }
  };
};

export const getAuthClientPoliciesListByClient = id => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [
        GET_AUTH_LIST_CLIENT_POLICIES_BY_CLIENT_REQUEST,
        GET_AUTH_LIST_CLIENT_POLICIES_BY_CLIENT_SUCCESS,
        GET_AUTH_LIST_CLIENT_POLICIES_BY_CLIENT_FAILURE
      ],
      authenticated: true,
      endpoint: `api/ClientPolicys/GetByClientId/${id}`,
      method: 'GET'
    }
  };
};

export const getAuthClientPoliciesList = () => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [GET_AUTH_LIST_CLIENT_POLICIES_REQUEST, GET_AUTH_LIST_CLIENT_POLICIES_SUCCESS, GET_AUTH_LIST_CLIENT_POLICIES_FAILURE],
      authenticated: true,
      endpoint: 'api/ClientPolicys',
      method: 'GET'
    }
  };
};

export const postAuthClientPoliciesList = values => {
  const username = localStorage.getItem('username') ? localStorage.getItem('username') : '';
  return {
    [CALL_INTAKE_V2_API]: {
      types: [POST_AUTH_LIST_CLIENT_POLICIES_REQUEST, POST_AUTH_LIST_CLIENT_POLICIES_SUCCESS, POST_AUTH_LIST_CLIENT_POLICIES_FAILURE],
      authenticated: true,
      endpoint: `api/ClientPolicys/${username}`,
      method: 'POST',
      payload: values
    }
  };
};

export const updateAuthClientPoliciesList = values => {
  const username = localStorage.getItem('username') ? localStorage.getItem('username') : '';
  return {
    [CALL_INTAKE_V2_API]: {
      types: [UPDATE_AUTH_LIST_CLIENT_POLICIES_REQUEST, UPDATE_AUTH_LIST_CLIENT_POLICIES_SUCCESS, UPDATE_AUTH_LIST_CLIENT_POLICIES_FAILURE],
      authenticated: true,
      endpoint: `api/ClientPolicys/${username}`,
      method: 'PUT',
      payload: values
    }
  };
};

export const deleteAuthClientPoliciesList = id => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [DELETE_AUTH_LIST_CLIENT_POLICIES_REQUEST, DELETE_AUTH_LIST_CLIENT_POLICIES_SUCCESS, DELETE_AUTH_LIST_CLIENT_POLICIES_FAILURE],
      authenticated: true,
      endpoint: `api/ClientsPolicys/${id}`,
      method: 'DELETE'
    }
  };
};

export const getAuthActivityLog = id => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [GET_ACTIVITY_LOG_REQUEST, GET_ACTIVITY_LOG_SUCCESS, GET_ACTIVITY_LOG_FAILURE],
      authenticated: true,
      endpoint: `api/authorizations/${id}/logs`,
      method: 'GET'
    }
  };
};

export const getUserSettings = id => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [GET_USER_SETTINGS_REQUEST, GET_USER_SETTINGS_SUCCESS, GET_USER_SETTINGS_FAILURE],
      authenticated: true,
      endpoint: `api/authorizations/${id}/userSetting`,
      method: 'GET'
    }
  };
};

export const postUserSettings = values => {
  const username = localStorage.getItem('username') ? localStorage.getItem('username') : '';
  return {
    [CALL_INTAKE_V2_API]: {
      types: [POST_USER_SETTINGS_REQUEST, POST_USER_SETTINGS_SUCCESS, POST_USER_SETTINGS_FAILURE],
      authenticated: true,
      endpoint: `api/authorizations/userSetting/${username}`,
      method: 'POST',
      payload: values
    }
  };
};

export const updateUserSettings = values => {
  const username = localStorage.getItem('username') ? localStorage.getItem('username') : '';
  return {
    [CALL_INTAKE_V2_API]: {
      types: [UPDATE_USER_SETTINGS_REQUEST, UPDATE_USER_SETTINGS_SUCCESS, UPDATE_USER_SETTINGS_FAILURE],
      authenticated: true,
      endpoint: `api/authorizations/userSetting/${username}`,
      method: 'PUT',
      payload: values
    }
  };
};

export const getFamilyMembers = authId => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [GET_FAMILY_REQUEST, GET_FAMILY_SUCCESS, GET_FAMILY_FAILURE],
      authenticated: true,
      endpoint: `api/authorizations/${authId}/family`,
      method: 'GET'
    }
  };
};

export const postFamilyMember = (values, authId) => {
  // const username = localStorage.getItem('username') ? localStorage.getItem('username') : '';
  return {
    [CALL_INTAKE_V2_API]: {
      types: [POST_FAMILY_REQUEST, POST_FAMILY_SUCCESS, POST_FAMILY_FAILURE],
      authenticated: true,
      endpoint: `api/authorizations/${authId}/familyMembers`,
      method: 'POST',
      payload: values
    }
  };
};

export const updateFamilyMember = (values, authId) => {
  // const username = localStorage.getItem('username') ? localStorage.getItem('username') : '';
  return {
    [CALL_INTAKE_V2_API]: {
      types: [UPDATE_FAMILY_REQUEST, UPDATE_FAMILY_SUCCESS, UPDATE_FAMILY_FAILURE],
      authenticated: true,
      endpoint: `api/authorizations/${authId}/familyMembers/${values.familyMemberId}`,
      method: 'PUT',
      payload: values
    }
  };
};

export const deleteFamilyMember = (authId, id) => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [DELETE_FAMILY_REQUEST, DELETE_FAMILY_SUCCESS, DELETE_FAMILY_FAILURE],
      authenticated: true,
      endpoint: `api/authorizations/${authId}/familyMembers/${id}`,
      method: 'DELETE'
    }
  };
};

export const updateFamilyMembersState = family => {
  return {
    type: UPDATE_FAMILY_DATA,
    response: family
  };
};

export const getFamilyPets = authId => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [GET_FAMILY_PET_REQUEST, GET_FAMILY_PET_SUCCESS, GET_FAMILY_PET_FAILURE],
      authenticated: true,
      endpoint: `api/authorizations/${authId}/familyPet`,
      method: 'GET'
    }
  };
};

export const postFamilyPet = (values, authId) => {
  // const username = localStorage.getItem('username') ? localStorage.getItem('username') : '';
  return {
    [CALL_INTAKE_V2_API]: {
      types: [POST_FAMILY_PET_REQUEST, POST_FAMILY_PET_SUCCESS, POST_FAMILY_PET_FAILURE],
      authenticated: true,
      endpoint: `api/authorizations/${authId}/pets`,
      method: 'POST',
      payload: values
    }
  };
};

export const updateFamilyPet = (values, authId) => {
  // const username = localStorage.getItem('username') ? localStorage.getItem('username') : '';
  return {
    [CALL_INTAKE_V2_API]: {
      types: [UPDATE_FAMILY_PET_REQUEST, UPDATE_FAMILY_PET_SUCCESS, UPDATE_FAMILY_PET_FAILURE],
      authenticated: true,
      endpoint: `api/authorizations/${authId}/pets/${values.petsId}`,
      method: 'PUT',
      payload: values
    }
  };
};

export const deleteFamilyPet = (authId, id) => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [DELETE_FAMILY_PET_REQUEST, DELETE_FAMILY_PET_SUCCESS, DELETE_FAMILY_PET_FAILURE],
      authenticated: true,
      endpoint: `api/authorizations/${authId}/pets/${id}`,
      method: 'DELETE'
    }
  };
};

export const updateFamilyPetsState = familyPets => {
  return {
    type: UPDATE_FAMILY_PET_DATA,
    response: familyPets
  };
};

export const getFinanceAndTax = authId => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [GET_FINANCE_AND_TAX_REQUEST, GET_FINANCE_AND_TAX_SUCCESS, GET_FINANCE_AND_TAX_FAILURE],
      authenticated: true,
      endpoint: `api/authorizations/${authId}/financeAndTax`,
      method: 'GET'
    }
  };
};

export const postFinanceAndTax = values => {
  const username = localStorage.getItem('username') ? localStorage.getItem('username') : '';
  return {
    [CALL_INTAKE_V2_API]: {
      types: [POST_FINANCE_AND_TAX_REQUEST, POST_FINANCE_AND_TAX_SUCCESS, POST_FINANCE_AND_TAX_FAILURE],
      authenticated: true,
      endpoint: `api/authorizations/financeAndTax/${username}`,
      method: 'POST',
      payload: values
    }
  };
};

export const updateFinanceAndTax = values => {
  const username = localStorage.getItem('username') ? localStorage.getItem('username') : '';
  return {
    [CALL_INTAKE_V2_API]: {
      types: [UPDATE_FINANCE_AND_TAX_REQUEST, UPDATE_FINANCE_AND_TAX_SUCCESS, UPDATE_FINANCE_AND_TAX_FAILURE],
      authenticated: true,
      endpoint: `api/authorizations/financeAndTax/${username}`,
      method: 'PUT',
      payload: values
    }
  };
};

export const getAddress = id => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [GET_ADDRESS_REQUEST, GET_ADDRESS_SUCCESS, GET_ADDRESS_FAILURE],
      authenticated: true,
      endpoint: `api/authorizations/${id}/addresses`,
      method: 'GET'
    }
  };
};

export const postAddress = (id, values) => {
  // const username = localStorage.getItem('username') ? localStorage.getItem('username') : '';
  return {
    [CALL_INTAKE_V2_API]: {
      types: [POST_ADDRESS_REQUEST, POST_ADDRESS_SUCCESS, POST_ADDRESS_FAILURE],
      authenticated: true,
      endpoint: `api/authorizations/${id}/addresses`,
      method: 'POST',
      payload: values
    }
  };
};

export const updateAddress = (id, values) => {
  // const username = localStorage.getItem('username') ? localStorage.getItem('username') : '';
  return {
    [CALL_INTAKE_V2_API]: {
      types: [UPDATE_ADDRESS_REQUEST, UPDATE_ADDRESS_SUCCESS, UPDATE_ADDRESS_FAILURE],
      authenticated: true,
      endpoint: `api/authorizations/${id}/addresses/${values.addressId}`,
      method: 'PUT',
      payload: values
    }
  };
};

export const deleteAddress = (authId, id) => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [DELETE_ADDRESS_REQUEST, DELETE_ADDRESS_SUCCESS, DELETE_ADDRESS_FAILURE],
      authenticated: true,
      endpoint: `api/authorizations/${authId}/addresses/${id}`,
      method: 'DELETE'
    }
  };
};

export const getAuthTripsByAuthId = authorizationId => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [GET_AUTH_TRIPS_REQUEST, GET_AUTH_TRIPS_SUCCESS, GET_AUTH_TRIPS_FAILURE],
      authenticated: true,
      endpoint: `api/authorizations/authTrip/getByAuth/${authorizationId}`,
      method: 'GET'
    }
  };
};

export const getAuthTripsById = tripId => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [GET_AUTH_TRIP_BY_ID_REQUEST, GET_AUTH_TRIP_BY_ID_SUCCESS, GET_AUTH_TRIP_BY_ID_FAILURE],
      authenticated: true,
      endpoint: `api/authorizations/authTrip/getById/${tripId}`,
      method: 'GET'
    }
  };
};

export const postAuthTrip = values => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [POST_AUTH_TRIP_REQUEST, POST_AUTH_TRIP_SUCCESS, POST_AUTH_TRIP_FAILURE],
      authenticated: true,
      endpoint: `api/authorizations/authTrip`,
      method: 'POST',
      payload: values
    }
  };
};

export const updateAuthTrip = values => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [UPDATE_AUTH_TRIP_REQUEST, UPDATE_AUTH_TRIP_SUCCESS, UPDATE_AUTH_TRIP_FAILURE],
      authenticated: true,
      endpoint: `api/authorizations/authTrip`,
      method: 'PUT',
      payload: values
    }
  };
};

export const deleteAuthTrip = id => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [DELETE_AUTH_TRIP_REQUEST, DELETE_AUTH_TRIP_SUCCESS, DELETE_AUTH_TRIP_FAILURE],
      authenticated: true,
      endpoint: `api/authorizations/authTrip/${id}`,
      method: 'DELETE'
    }
  };
};

export const getAuthorizationBanking = authorizationId => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [GET_AUTHORIZATION_BANKING_REQUEST, GET_AUTHORIZATION_BANKING_SUCCESS, GET_AUTHORIZATION_BANKING_FAILURE],
      authenticated: true,
      endpoint: `api/authorizations/${authorizationId}/banks`,
      method: 'GET'
    }
  };
};

export const postAuthorizationBank = (authorizationId, values) => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [POST_AUTHORIZATION_BANKING_REQUEST, POST_AUTHORIZATION_BANKING_SUCCESS, POST_AUTHORIZATION_BANKING_FAILURE],
      authenticated: true,
      endpoint: `api/authorizations/${authorizationId}/banks`,
      method: 'POST',
      payload: values
    }
  };
};

export const updateAuthorizationBank = (authorizationId, values) => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [UPDATE_AUTHORIZATION_BANKING_REQUEST, UPDATE_AUTHORIZATION_BANKING_SUCCESS, UPDATE_AUTHORIZATION_BANKING_FAILURE],
      authenticated: true,
      endpoint: `api/authorizations/${authorizationId}/banks`,
      method: 'PUT',
      payload: values
    }
  };
};

export const deleteAuthorizationBank = (authorizationId, bankId) => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [DELETE_AUTHORIZATION_BANKING_REQUEST, DELETE_AUTHORIZATION_BANKING_SUCCESS, DELETE_AUTHORIZATION_BANKING_FAILURE],
      authenticated: true,
      endpoint: `api/authorizations/${authorizationId}/banks/${bankId}`,
      method: 'DELETE'
    }
  };
};

export const getAuthorizationAreaTour = areaTourId => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [GET_AUTHORIZATION_AREA_TOUR_REQUEST, GET_AUTHORIZATION_AREA_TOUR_SUCCESS, GET_AUTHORIZATION_AREA_TOUR_FAILURE],
      authenticated: true,
      endpoint: `api/authorizations/areaTour/${areaTourId}`,
      method: 'GET'
    }
  };
};

export const postAuthorizationAreaTour = values => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [POST_AUTHORIZATION_AREA_TOUR_REQUEST, POST_AUTHORIZATION_AREA_TOUR_SUCCESS, POST_AUTHORIZATION_AREA_TOUR_FAILURE],
      authenticated: true,
      endpoint: `api/authorizations/areaTour/`,
      method: 'POST',
      payload: values
    }
  };
};

export const updateAuthorizationAreaTour = values => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [UPDATE_AUTHORIZATION_AREA_TOUR_REQUEST, UPDATE_AUTHORIZATION_AREA_TOUR_SUCCESS, UPDATE_AUTHORIZATION_AREA_TOUR_FAILURE],
      authenticated: true,
      endpoint: `api/authorizations/areaTour/`,
      method: 'PUT',
      payload: values
    }
  };
};

export const deleteAuthorizationAreaTour = areaTourId => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [DELETE_AUTHORIZATION_AREA_TOUR_REQUEST, DELETE_AUTHORIZATION_AREA_TOUR_SUCCESS, DELETE_AUTHORIZATION_AREA_TOUR_FAILURE],
      authenticated: true,
      endpoint: `api/authorizations/areaTour/${areaTourId}`,
      method: 'DELETE'
    }
  };
};

export const getAuthorizationComments = authId => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [GET_AUTHORIZATION_COMMENTS_REQUEST, GET_AUTHORIZATION_COMMENTS_SUCCESS, GET_AUTHORIZATION_COMMENTS_FAILURE],
      authenticated: true,
      endpoint: `api/authorizations/${authId}/comments`,
      method: 'GET'
    }
  };
};

export const postAuthorizationComment = (values, authId) => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [POST_AUTHORIZATION_COMMENTS_REQUEST, POST_AUTHORIZATION_COMMENTS_SUCCESS, POST_AUTHORIZATION_COMMENTS_FAILURE],
      authenticated: true,
      endpoint: `api/authorizations/${authId}/comments`,
      method: 'POST',
      payload: values
    }
  };
};

export const updateAuthorizationComment = (values, authId, commentId) => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [UPDATE_AUTHORIZATION_COMMENTS_REQUEST, UPDATE_AUTHORIZATION_COMMENTS_SUCCESS, UPDATE_AUTHORIZATION_COMMENTS_FAILURE],
      authenticated: true,
      endpoint: `api/authorizations/${authId}/comments/${commentId}`,
      method: 'PUT',
      payload: values
    }
  };
};

export const deleteAuthorizationComment = (authId, commentId) => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [DELETE_AUTHORIZATION_COMMENTS_REQUEST, DELETE_AUTHORIZATION_COMMENTS_SUCCESS, DELETE_AUTHORIZATION_COMMENTS_FAILURE],
      authenticated: true,
      endpoint: `api/authorizations/${authId}/comments/${commentId}`,
      method: 'DELETE'
    }
  };
};

export const postAuthCommentsAttachment = (attachment, authId, commentId) => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [POST_AUTH_COMMENTS_ATTACHMENT_REQUEST, POST_AUTH_COMMENTS_ATTACHMENT_SUCCESS, POST_AUTH_COMMENTS_ATTACHMENT_FAILURE],
      authenticated: true,
      endpoint: `api/authorizations/${authId}/comments/${commentId}/attachments`,
      method: 'POST',
      payload: attachment,
      context: { commentId: commentId }
    }
  };
};

export const updateAuthCommentsAttachment = (attachment, authId, commentId) => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [UPDATE_AUTH_COMMENTS_ATTACHMENT_REQUEST, UPDATE_AUTH_COMMENTS_ATTACHMENT_SUCCESS, UPDATE_AUTH_COMMENTS_ATTACHMENT_FAILURE],
      authenticated: true,
      endpoint: `api/authorizations/${authId}/comments/${commentId}/attachments`,
      method: 'PUT',
      payload: attachment,
      context: { commentId: commentId }
    }
  };
};

export const deleteAuthCommentsAttachment = (authId, commentId, attachmentId) => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [DELETE_AUTH_COMMENTS_ATTACHMENT_REQUEST, DELETE_AUTH_COMMENTS_ATTACHMENT_SUCCESS, DELETE_AUTH_COMMENTS_ATTACHMENT_FAILURE],
      authenticated: true,
      endpoint: `api/authorizations/${authId}/comments/${commentId}/attachments/${attachmentId}`,
      method: 'DELETE',
      context: { commentId: commentId }
    }
  };
};

export const getAuthorizationSentTemplates = authId => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [GET_AUTHORIZATION_SENT_TEMPLATES_REQUEST, GET_AUTHORIZATION_SENT_TEMPLATES_SUCCESS, GET_AUTHORIZATION_SENT_TEMPLATES_FAILURE],
      authenticated: true,
      endpoint: `api/authorizations/${authId}/templates/sent`,
      method: 'GET'
    }
  };
};

export const getAuthCustomFieldsAndValues = authId => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [
        GET_AUTH_CUSTOM_FIELDS_AND_VALUES_REQUEST,
        GET_AUTH_CUSTOM_FIELDS_AND_VALUES_SUCCESS,
        GET_AUTH_CUSTOM_FIELDS_AND_VALUES_FAILURE
      ],
      authenticated: true,
      endpoint: `api/authorizations/${authId}/customFields`,
      method: 'GET'
    }
  };
};

export const getAuthCustomFieldValues = authId => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [GET_AUTH_CUSTOM_FIELD_VALUES_REQUEST, GET_AUTH_CUSTOM_FIELD_VALUES_SUCCESS, GET_AUTH_CUSTOM_FIELD_VALUES_FAILURE],
      authenticated: true,
      endpoint: `api/authorizations/${authId}/customFieldValues`,
      method: 'GET'
    }
  };
};

export const postAuthCustomFieldValue = values => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [POST_AUTH_CUSTOM_FIELD_VALUE_REQUEST, POST_AUTH_CUSTOM_FIELD_VALUE_SUCCESS, POST_AUTH_CUSTOM_FIELD_VALUE_FAILURE],
      authenticated: true,
      endpoint: `api/authorizations/customFieldValue`,
      method: 'POST',
      payload: values
    }
  };
};

export const postAllCustomFieldValuesForAuth = authId => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [POST_ALL_AUTH_CUSTOM_FIELD_VALUE_REQUEST, POST_ALL_AUTH_CUSTOM_FIELD_VALUE_SUCCESS, POST_ALL_AUTH_CUSTOM_FIELD_VALUE_FAILURE],
      authenticated: true,
      endpoint: `api/authorizations/${authId}/customFieldValue/insertAll`,
      method: 'POST'
    }
  };
};

export const updateAuthCustomFieldValue = values => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [UPDATE_AUTH_CUSTOM_FIELD_VALUE_REQUEST, UPDATE_AUTH_CUSTOM_FIELD_VALUE_SUCCESS, UPDATE_AUTH_CUSTOM_FIELD_VALUE_FAILURE],
      authenticated: true,
      endpoint: `api/authorizations/customFieldValue`,
      method: 'PUT',
      payload: values
    }
  };
};

export const deleteAuthCustomFieldValue = customFieldValueId => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [DELETE_AUTH_CUSTOM_FIELD_VALUE_REQUEST, DELETE_AUTH_CUSTOM_FIELD_VALUE_SUCCESS, DELETE_AUTH_CUSTOM_FIELD_VALUE_FAILURE],
      authenticated: true,
      endpoint: `api/authorizations/customFieldValue/${customFieldValueId}`,
      method: 'DELETE'
    }
  };
};

export const postAuthPtCode = (fileId, values) => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [POST_AUTH_PT_CODE_REQUEST, POST_AUTH_PT_CODE_SUCCESS, POST_AUTH_PT_CODE_FAILURE],
      authenticated: true,
      endpoint: `api/authorizations/${fileId}/ptcodes`,
      method: 'POST',
      payload: values
    }
  };
};

export const updateAuthPtCode = (fileId, ptCodeHistoryId, values) => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [UPDATE_AUTH_PT_CODE_REQUEST, UPDATE_AUTH_PT_CODE_SUCCESS, UPDATE_AUTH_PT_CODE_FAILURE],
      authenticated: true,
      endpoint: `api/authorizations/${fileId}/ptcodes/${ptCodeHistoryId}`,
      method: 'PUT',
      payload: values
    }
  };
};

export const deleteAuthPtCode = (fileId, ptCodeHistoryId) => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [DELETE_AUTH_PT_CODE_REQUEST, DELETE_AUTH_PT_CODE_SUCCESS, DELETE_AUTH_PT_CODE_FAILURE],
      authenticated: true,
      endpoint: `api/authorizations/${fileId}/ptcodes/${ptCodeHistoryId}`,
      method: 'DELETE'
    }
  };
};

export const getTasksByFileId = fileId => ({
  [CALL_INTAKE_V2_API]: {
    types: [GET_FILE_TASKS_REQUEST, GET_FILE_TASKS_SUCCESS, GET_FILE_TASKS_FAILURE],
    authenticated: true,
    endpoint: `api/tasks/dashboard/getByFileId/${fileId}`,
    method: 'GET'
  }
});

export const createFileTask = taskPayload => ({
  [CALL_INTAKE_V2_API]: {
    types: [CREATE_FILE_TASK_REQUEST, CREATE_FILE_TASK_SUCCESS, CREATE_FILE_TASK_FAILURE],
    authenticated: true,
    endpoint: 'api/tasks',
    method: 'POST',
    payload: taskPayload
  }
});

export const getFeeRecordsByFileId = fileId => ({
  [CALL_INTAKE_V2_API]: {
    types: [GET_FEE_RECORDS_REQUEST, GET_FEE_RECORDS_SUCCESS, GET_FEE_RECORDS_FAILURE],
    authenticated: true,
    endpoint: `api/authorizations/feeRecords/${fileId}`,
    method: 'GET'
  }
});

export const getServiceStatusDates = fileId => ({
  [CALL_INTAKE_V2_API]: {
    types: [GET_SERVICE_STATUS_DATES_REQUEST, GET_SERVICE_STATUS_DATES_SUCCESS, GET_SERVICE_STATUS_DATES_FAILURE],
    authenticated: true,
    endpoint: `api/authorizations/serviceStatusDates/${fileId}`,
    method: 'GET'
  }
});

export const getSimilarAuthorizations = (request) => ({
  [CALL_INTAKE_V2_API]: {
    types: [GET_SIMILAR_AUTHORIZATIONS_REQUEST, GET_SIMILAR_AUTHORIZATIONS_SUCCESS, GET_SIMILAR_AUTHORIZATIONS_FAILURE],
    authenticated: true,
    endpoint: `api/authorizations/similarAuths`,
    method: 'POST',
    payload: request
  }
});

export const resendWelcomeEmail = (fileId, noMobileNumber) => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [RESEND_WELCOME_EMAIL_REQUEST, RESEND_WELCOME_EMAIL_SUCCESS, RESEND_WELCOME_EMAIL_FAILURE],
      authenticated: true,
      endpoint: `api/authorizations/${fileId}/resendRelosourceInvite?hasMobileNumber=${noMobileNumber}`,
      method: 'POST'
    }
  };
};
